const GoogleAnalyticEventType = () => {
  const GA4_EVENTS = {
    ORGANIC_SIGNUP_EVENT: {
      event_name: "signupComplete", // Use snake_case
      parameters: {
        signup_type: "organic" // Use snake_case for parameter keys
      }
    },
    REFERRAL_SIGNUP_EVENT: {
      event_name: "signupComplete",
      parameters: {
        signup_type: "referral"
      }
    },
    SIGNUP_COMPLETE_DEMO_ACCOUNT: {
      event_name: "completeDemoAccount",
      parameters: {
        signup_type: "demo"
      } // Add parameters if needed
    },
    COMPLETE_DEMO_ACCOUNT: {
      event_name: "complete_demo_account",
      parameters: {
        action: "registered",
        email: null // Omit if null in actual usage
      }
    },
    LOGIN_EVENT: {
      event_name: "login",
      parameters: {}
    },
    SUBMIT_INVOICE_EVENT: {
      event_name: "submitInvoice",
      parameters: {} // Add parameters if needed
    },
    MANUAL_INVOICE_UPLOAD_EVENT: {
      event_name: "manualInvoiceUpload",
      parameters: {} // Add parameters if needed
    },
    PARTNER_SUBMIT: {
      event_name: "partner_submit",
      parameters: {
        beneficial_owner_id: null, // Omit if null in actual usage
        ip_address: null // Omit if null in actual usage
      }
    },
    APPROVE_INVOICE: {
      event_name: "approve",
      parameters: {
        ft_customer_id: null, // Omit if null in actual usage
        ft_quote_id: null, // Omit if null in actual usage
        current_status: null // Omit if null in actual usage
      }
    },
    CLIENT_STATUS_PRE_APPROVED: {
      event_name: "PreApprove",
      parameters: {
        client_status: "pre_approved"
      }
    },
    CLIENT_STATUS_APPROVED: {
      event_name: "approved",
      parameters: {
        client_status: "approved"
      }
    },
    MYOB_CONNECT_ACCOUNTING_SOFTWARE: {
      event_name: "linkedAccounting",
      parameters: {
        accounting_software: "myob"
      }
    },
    XERO_CONNECT_ACCOUNTING_SOFTWARE: {
      event_name: "linkedAccounting",
      parameters: {
        accounting_software: "xero"
      }
    },
    QUICKBOOK_CONNECT_ACCOUNTING_SOFTWARE: {
      event_name: "linkedAccounting",
      parameters: {
        accounting_software: "quickbooks"
      }
    },
    RECKON_CONNECT_ACCOUNTING_SOFTWARE: {
      event_name: "linkedAccounting",
      parameters: {
        accounting_software: "reckon"
      }
    },
    COMPLETE_AML: {
      event_name: "complete_aml",
      parameters: {} // Add parameters if needed
    },
    APPLYID_COMPLETE: {
      event_name: "onboarding_id_complete",
      parameters: {
        ft_customer_id: null // Omit if null in actual usage
      }
    }
  };

  return { GA4_EVENTS };
};

export default GoogleAnalyticEventType;
